import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiBase } from './api-config';
import { Device, CreateDeviceDto } from '../models/device.model';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  private http = inject(HttpClient);
  private url = `${apiBase}/devices`;

  getAll(customerId?: number): Observable<Device[]> {
    let params: any = {};
    if (customerId) params.customerId = customerId.toString();
    return this.http.get<Device[]>(this.url, { params });
  }

  getByCustomer(customerId: number): Observable<Device[]> {
    return this.http.get<Device[]>(`${apiBase}/customers/${customerId}/devices`);
  }

  getById(id: number): Observable<Device> {
    return this.http.get<Device>(`${this.url}/${id}`);
  }

  create(dto: CreateDeviceDto): Observable<Device> {
    return this.http.post<Device>(this.url, dto);
  }

  update(id: number, dto: Partial<CreateDeviceDto>): Observable<Device> {
    return this.http.put<Device>(`${this.url}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
